import { render, staticRenderFns } from "./ButtonBottom.vue?vue&type=template&id=8179a74c&"
import script from "./ButtonBottom.vue?vue&type=script&lang=js&"
export * from "./ButtonBottom.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBottom.vue?vue&type=style&index=0&id=8179a74c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports